import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
// 首页
const index = () => import('../views/index')
// 公路价格查询
const load = () => import('../views/load')
// 铁路价格查询
const railway = () => import('../views/railway')
// 海运价格查询
const route = () => import('../views/route')
const router = new VueRouter({
	mode: 'history',
	base: __dirname,
	routes: [{
			path: '/',
			component: index,
			name: '首页',
			meta: {
				title: '首页'
			}
		},
		{
			path: '/load',
			component: load,
			name: '公路价格查询',
			meta: {
				title: '首页'
			}
		},
		{
			path: '/railway',
			component: railway,
			name: '铁路价格查询'
		},
		{
			path: '/route',
			component: route,
			name: '海运价格查询'
		}
	]
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js